import React, { Component } from 'react';
import { ifProp } from 'styled-tools';
import styled, { css } from 'styled-components';
import ErrorAlert from 'components/ErrorAlert';

const ErrorBoundaryAlert = styled(ErrorAlert)`
  margin: 1.25rem;
  
  ${ifProp({$component: 'header'}, css`
    margin-bottom: -5rem;
  `)};
`;

const ErrorMessage = styled.h4`
  margin: 0;
`;

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('Error caught by Error Boundary:', error, info);
  }

  render() {
    const errorComponent = this.props.component ?? 'block';

    if (this.state.hasError) {
      return (
        <div>
          <ErrorBoundaryAlert $component={this.props.component}>
            <ErrorMessage>{`Unable to display ${errorComponent} content.`}</ErrorMessage>
          </ErrorBoundaryAlert>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;